import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function ImageUpload({ onUploaded, label = "Carica foto", testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data.url);
      toast.success("Immagine caricata");
    } catch (err) {
      toast.error("Caricamento non riuscito. Usa un'immagine (max 10MB).");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept="image/*" onChange={handle} className="hidden" data-testid={`${testid}-input`} />
      <Button type="button" variant="outline" size="sm" className="rounded-full" disabled={loading} onClick={() => inputRef.current?.click()} data-testid={testid}>
        {loading ? <Loader2 size={14} className="mr-1 animate-spin" /> : <Upload size={14} className="mr-1" />}
        {loading ? "Caricamento…" : label}
      </Button>
    </>
  );
}
